<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1300px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Company Banks"
      text="Edit Company Banks"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Company"
                disabled
                :value="companyBank.company.name"
              />
            </v-col>
          </v-row>

          <v-row>  
            <v-col>
              <span class="font-weight-bold pr-2">Banks:</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-icon
                    color="primary"
                    v-on="{ ...dialog, ...tooltip }"
                    @click="addRow"
                  >
                    mdi-plus
                  </v-icon>
                </template>
                <span>Add new row</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row
            v-if="localCompanyBank.details.length > 0"
            no-gutters
          >
            <v-col class="font-weight-bold">
              Default Bank
            </v-col>
          </v-row>

          <v-row
            v-for="(detail, counter) in localCompanyBank.details"
            :key="counter"
          >
            <v-col class="py-0">
              <v-checkbox
                v-model="detail.is_default"
                @click="defaultBank(counter)"
              />
            </v-col>
          
            <v-col
              cols="3"
              class="py-0"
            >
              <v-autocomplete
                v-model="detail.payroll_bank.id"
                :items="payrollBanks"
                item-text="name"
                item-value="id"
                hide-no-data
                hide-selected
                label="Banks"
              />
            </v-col>

            <v-col
              cols="2"
              class="py-0"
            >
              <v-text-field
                v-model="detail.bank_account_no"
                v-validate="bankValidate(localCompanyBank.details[counter].payroll_bank.id)"
                :name="'bank_account_no' + counter"
                label="Bank Account No."
                :error-messages="errors.collect('bank_account_no' + counter)"
                data-vv-as="bank account no"
              />
            </v-col>
            
            <v-col
              cols="2"
              class="py-0"
            >
              <v-text-field
                v-model="detail.originator_id"
                v-validate="originatorIdValidate(localCompanyBank.details[counter].payroll_bank.id)"
                :name="'originator_id' + counter"
                :error-messages="errors.collect('originator_id' + counter)"
                data-vv-as="originator id"
                label="Originator ID"
              />
            </v-col>
           
            <v-col
              cols="2"
              class="py-0"
            >
              <v-text-field
                v-model="detail.company_registered_id"
                v-validate="companyRegisteredIdValidate(localCompanyBank.details[counter].payroll_bank.id)"
                :name="'company_registered_id' + counter"
                label="Company Registered ID"
                :error-messages="errors.collect('company_registered_id' + counter)"
                data-vv-as="company registered id"
              />
            </v-col>

            <v-col
              cols="2"
              class="py-0"
            >
              <v-text-field
                v-model="detail.short_name"
                v-validate="shortNameValidate(localCompanyBank.details[counter].payroll_bank.id)"
                :name="'short_name' + counter"
                label="Short Name"
                :error-messages="errors.collect('short_name' + counter)"
                data-vv-as="short name"
              />
            </v-col>

            <v-col
              class="py-0"
              style="display:flex"
            >
              <v-icon
                v-if="!detail.is_default"
                color="error"
                @click="deleteRow(counter)"
              >
                mdi-window-close
              </v-icon>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      companyBank: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        payrollBanks: [],
        localCompanyBank: null,
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return
        this.localCompanyBank = { ...this.companyBank }

        this.$api.payrollBanks().list()
          .then(res => {
            this.payrollBanks = res.data
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.companyBanks().update(this.localCompanyBank.company.id, { company: this.localCompanyBank.company.id, banks: this.localCompanyBank.details })
              .then(response => {
                this.$emit('updated')
                this.$snack({ message: response.data.status })

                this.progressing = false
                this.dialog = false
              })
          })
      },

      addRow () {
        this.localCompanyBank.details.push({ payroll_bank: { id: null }, originator_id: null, company_registered_id: null, short_name: null, bank_account_no: null, is_default: 0 })
      },
      
      deleteRow (counter) {
        this.localCompanyBank.details.splice(counter, 1)
      },

      defaultBank (index) {
        this.localCompanyBank.details.map((item, i) => {
          if (i === index) {
            item.is_default = 1
          } else {
            item.is_default = 0
          }
        })
      },
      bankValidate (id) {
        if (!id) return 'required'
        if (id === 19) return 'required|max:12' // maybank
        return 'required'
      },

      originatorIdValidate (id) {
        if (!id) return ''
        if (id === 19) return 'required|max:5' // maybank
        return ''
      },

      companyRegisteredIdValidate (id) {
        if (!id) return ''
        if (id === 19) return 'required|max:3' // maybank
        return ''
      },

      shortNameValidate (id) {
        if (!id) return ''
        if (id === 20) return 'required|max:13' // maybank
        return ''
      },

    },
  }
</script>
